import { handleJsonResponse } from './fetchHelpers';

export async function getUserInfoRequest(treatCanaryApiUrl: string) {
  const { userName, roles } = await handleJsonResponse(
    fetch(`${treatCanaryApiUrl}/userinfo`, {
      method: 'GET',
    }),
  );

  return { userName, roles };
}
